import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getClientDetail(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/finflux-${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateClient(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/clients/${id}/`,
      method: HttpMethod.PUT
    };

    try {
      const res = await processRequest(ep, { data });
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getContractsByClientId(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${id}/contracts/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          pageSize: -1
        }
      });

      const { items, total } = processSuccessResponse(res);

      return { items, total };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientDocs(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${id}/docs/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          pageSize: -1
        }
      });

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientDocTypes() {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/client-doc-types/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async uploadDocument(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${id}/docs/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });

      const result = processSuccessResponse(res);

      return result;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async deleteDocument(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/client-docs/${id}:archive/`,
      method: HttpMethod.POST
    };

    try {
      await processRequest(ep);

      return true;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientNotes(clientId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${clientId}/notes/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          pageSize: -1
        }
      });

      const { items } = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addClientNotes(clientId, content) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${clientId}/notes/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {
        data: {
          content
        }
      });

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientBankAccounts(id) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/clients/${id}/bank-accounts/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createBankAccount(data) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/client-banks/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });

      const result = processSuccessResponse(res);

      return result;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateBankAccount(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/client-banks/${id}/`,
      method: HttpMethod.PATCH
    };

    try {
      const res = await processRequest(ep, { data });

      const result = processSuccessResponse(res);

      return result;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async deleteBankAccount(id) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/client-banks/${id}/`,
      method: HttpMethod.DELETE
    };

    try {
      await processRequest(ep);

      return true;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getActiveContractsByClientId(id, filters) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/clients/${id}/active-contracts/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: filters });

      const { items, total } = processSuccessResponse(res);

      return { items, total };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getCloseContractsByClientId(id, filters) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/clients/${id}/close-contracts/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: filters });

      const { items, total } = processSuccessResponse(res);

      return { items, total };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },
};
